"use client";
import React from "react";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { persistor, store } from "./store";
import { ThemeSettings } from "@/utils/theme/Theme";
import "@/utils/i18n";
import { CacheProvider } from "@emotion/react";
import createEmotionCache from "@/utils/theme/createEmotionCache";

const ThemeProviderWrapper = ({ children }) => {
  const theme = ThemeSettings();
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};
const clientSideEmotionCache = createEmotionCache();

export function Providers({ children }) {
  const [queryClient] = React.useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 60 * 1000,
            refetchOnWindowFocus: false,
            retry: 1,
          },
        },
      }),
  );

  return (
    <CacheProvider value={clientSideEmotionCache}>
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <ThemeProviderWrapper>
              <CssBaseline />
              {children}
            </ThemeProviderWrapper>
          </PersistGate>
        </Provider>
      </QueryClientProvider>
    </CacheProvider>
  );
}
